export const assembleFiltersFromFormValues = (values: any) => {
  const filter = {
    webSocketHistoryType: values.webSocketHistoryType
  }
  return filter
}
